import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "simplePage"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 1,
    class: "mt-5"
};
const _hoisted_4 = { class: "benefits left" };
import { onMounted } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useProducts } from '@/composables/useProducts';
import BarArrowButton from './elements/BarArrowButton.vue';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BenefitsPage',
    setup(__props) {
        const state = useAppState();
        useAuth();
        const { getCustomer, getEmployer } = useCustomer();
        const { getProducts } = useProducts();
        function onLoad() {
            getCustomer(() => {
                if (state.customer) {
                    getEmployer(state.customer.employerID);
                    getProducts(state.customer.employerID);
                }
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: _unref(state).employer ? _unref(state).employer.name + ' Benefits' : 'Benefits'
                }, null, 8, ["title"]),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).products.length > 0 && _unref(state).employer
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).products.length > 0 && _unref(state).employer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("h1", null, _toDisplayString(_unref(state).employer.name) + " Benefits", 1),
                                _createElementVNode("p", null, _toDisplayString(_unref(state).employer.benefitsDescription), 1),
                                (_unref(state).employer.logoUri && _unref(state).employer.logoUri != '')
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        class: "heroImg mt-2",
                                        src: _unref(state).employer.logoUri
                                    }, null, 8, _hoisted_2))
                                    : _createCommentVNode("", true),
                                (!_unref(state).employer.logoUri || _unref(state).employer.logoUri == '')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_4, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).products, (product) => {
                                        return (_openBlock(), _createBlock(BarArrowButton, {
                                            class: "mt-3",
                                            large: true,
                                            key: product.id,
                                            icon: product.thumbnail,
                                            title: product.name,
                                            href: product.actionButtonText ? '/#/Products/' + product.id : product.websiteUrl,
                                            moreRounded: false
                                        }, null, 8, ["icon", "title", "href"]));
                                    }), 128))
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
